import { TierPresentations } from '../constants/TierPresentations';

export const getPresentationForTier = (id) => TierPresentations[id];
